import { render } from "./Smiles3DPreview.vue?vue&type=template&id=12f0e9da&scoped=true"
import script from "./Smiles3DPreview.vue?vue&type=script&lang=js"
export * from "./Smiles3DPreview.vue?vue&type=script&lang=js"

import "./Smiles3DPreview.vue?vue&type=style&index=0&id=12f0e9da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f0e9da"]])

export default __exports__